import { useState } from "react";
import "./Departments.css";

const data = {
  org: "Zilla Parishad Pune",
  title: "Finance Department",
  titleMarathi: "वित्त विभाग",
  emblem: "💰",
  intro: `All financial transactions of the Zilla Parishad are handled by the Finance Department. The Head of the Finance Department is the Chief Accounts and Finance Officer — an officer of Deputy Director rank in the Maharashtra Finance and Accounts Service. He works as the Financial Advisor and Primary Auditor of the Zilla Parishad for accounts, budget estimates, and financial rules. No authority approves any financial transaction without his advice.`,
  stats: [
    { value: "8,991", label: "Teachers' Pension Holders" },
    { value: "4,473", label: "Non-Teaching Pension Holders" },
    { value: "8", label: "Department Branches" },
    { value: "5", label: "Fund Types Maintained" },
    { value: "Class 1", label: "Dy. Chief Accounts Officer" },
    { value: "Class 2", label: "3 Accounts Officers" },
  ],
  info: [
    { key: "Head Officer", val: "Chief Accounts & Finance Officer" },
    { key: "Officer Rank", val: "Deputy Director" },
    { key: "Service", val: "Maharashtra Finance & Accounts" },
    { key: "Telephone", val: "020-26135426" },
    { key: "Address", val: "District Level Office" },
  ],
  contact: [
    { icon: "📞", label: "020-26135426" },
    { icon: "🏢", label: "District Level Office" },
    { icon: "🏛️", label: "Zilla Parishad Pune" },
  ],
  branches: [
    {
      name: "Establishment Branch",
      desc: "Handles establishment matters of Gazetted Officers and Accounts Cadre employees — appointments, promotions, transfers, advance pay increments, seniority lists, retirement, confidential records, 54-year review, group insurance, and medical reimbursement proposals.",
    },
    {
      name: "Cash Branch",
      desc: "After approval of salary, construction/roads and other payments, operational checks are prepared and distributed. Checks and deposits received from treasury are recorded in the cash book. Daily/monthly deposit and expenditure records are reconciled with the bank.",
    },
    {
      name: "Store Department / Branch",
      desc: "As per Rule 202 of Maharashtra ZP and Panchayat Samiti Accounts Code 1968, inventory of Zilla Parishad is maintained. Stationery, forms and records required by all departments and Panchayat Samitis are purchased and distributed through this branch.",
    },
    {
      name: "Central Audit Branch",
      desc: "Administrative/expenditure approval given on proposals from Heads of Accounts. All payments are checked and remarks recorded. Monthly accounts of headquarters are prepared. Entire process of planning and distributing 15th Finance Commission funds is handled here.",
    },
    {
      name: "Budget & Reconciliation Branch",
      desc: "As per Maharashtra ZP and Panchayat Samiti Act 1961, Rules 137 & 138, original and revised budgets are prepared, scrutinized in Finance Committee, and submitted to the general meeting for approval. Approved funds are distributed to concerned departments.",
    },
    {
      name: "Compilation Branch",
      desc: "Prepares monthly accounts by collecting receipts and expenditure of all Panchayat Samitis and headquarters. Annual accounts are prepared from monthly accounts, scrutinized in Finance Committee, approved in ZP general meeting, and published in Government Gazette before 15 November.",
    },
    {
      name: "Provident Fund Branch",
      desc: "Maintains PF accounts of all non-teaching Class 3 and Class 4 ZP employees using a computerized system. Refund/non-refund and final payment cheques are processed from treasury. Deposit-linked scheme benefits are paid to heirs of deceased employees. Group insurance amounts are disbursed.",
    },
    {
      name: "External Audit Branch",
      desc: "Internal audit of accounts of Heads of Accounts and Panchayat Samitis for completed financial years. Coordinates resolution of audit objections from Local Fund Accounts, Panchayat Raj Samiti and Accountant General's Office. Verifies revised salary determinations per Pay Commission.",
    },
    {
      name: "Pension Branch",
      desc: "Under Maharashtra Civil Services (Pension) Rules 1982, retirement pay is sanctioned for Class 3 employees (age 58) and Class 4 employees (age 60). 8,991 teachers and 4,473 non-teaching pension holders under Pune ZP receive monthly pension within the prescribed period.",
    },
  ],
  funds: [
    "Zilla Parishad Scheme (District Fund)",
    "Agency Scheme (Agency Fund)",
    "Transferred Scheme (Government Fund)",
    "Repair and Maintenance Fund",
    "Depreciation Fund",
  ],
  links: [
    { label: "Pension", url: "https://esanchit.co.in", icon: "🔗" },
    { label: "GPF", url: "https://esanchit.co.in", icon: "🔗" },
    { label: "GIS", url: "https://esanchit.co.in", icon: "🔗" },
    { label: "MRMS", url: "https://esanchit.co.in", icon: "🔗" },
    { label: "NPS / DCPS", url: "https://www.gpfzppune.in", icon: "🔗" },
    { label: "GPF Slip", url: "https://www.gpfzppune.in", icon: "🔗" },
    { label: "Salary Verification Form", url: "https://forms.gle/FS1SSfbKcyJzm4379", icon: "📝" },
  ],
  services: [
    "Budget Preparation",
    "Salary Disbursement",
    "Pension Management",
    "Provident Fund",
    "Internal Audit",
    "External Audit",
    "Store Management",
    "Fund Distribution",
  ],
  tabs: ["Overview", "Branches", "Services", "Quick Links", "Contact"],
};

export default function FinanceVibhag() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <div>
      {/* Top Strip */}
      <div className="dept-top-strip">
        <span>💰 Zilla Parishad Pune — Finance Department</span>
        <span>📞 020-26135426</span>
      </div>

      {/* Header */}
      <div className="dept-header">
        <div className="dept-header-emblem">{data.emblem}</div>
        <div className="dept-header-text">
          <div className="dept-header-org">{data.org}</div>
          <div className="dept-header-title">{data.title}</div>
          <div className="dept-header-subtitle">{data.titleMarathi}</div>
        </div>
        <div className="dept-header-badge">Chief Accounts & Finance Officer</div>
      </div>

      {/* Nav Tabs */}
      <div className="dept-nav">
        {data.tabs.map((tab) => (
          <button
            key={tab}
            className={`dept-nav-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="dept-main">

        {/* Intro Hero */}
        <div className="dept-intro">
          <div className="dept-intro-label">About the Department</div>
          <div className="dept-intro-text">{data.intro}</div>
        </div>

        {/* Stats Row */}
        <div className="dept-stats">
          {data.stats.map((s, i) => (
            <div className="dept-stat-card" key={i}>
              <div className="dept-stat-value">{s.value}</div>
              <div className="dept-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Branches Section */}
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>

          <div className="dept-section">
            <div className="dept-section-header">
              <div className="dept-section-icon">🏦</div>
              <div className="dept-section-title">Department Branches</div>
            </div>
            <div className="scheme-list">
              {data.branches.map((branch, i) => (
                <div className="scheme-card" key={i}>
                  <div className="scheme-card-name">{branch.name}</div>
                  <div className="scheme-card-desc">{branch.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="dept-section">
            <div className="dept-section-header">
              <div className="dept-section-icon">🔗</div>
              <div className="dept-section-title">Quick Links & Portals</div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              {data.links.map((link, i) => (
                <a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "14px 16px",
                    background: "var(--off-white)",
                    border: "1px solid var(--border)",
                    borderRadius: "var(--radius-sm)",
                    textDecoration: "none",
                    color: "var(--navy)",
                    fontWeight: "600",
                    fontSize: "0.88rem",
                    transition: "all 0.2s",
                    borderLeft: "4px solid var(--saffron)",
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "var(--saffron-light)"}
                  onMouseLeave={e => e.currentTarget.style.background = "var(--off-white)"}
                >
                  <span style={{ fontSize: "1.1rem" }}>{link.icon}</span>
                  {link.label}
                </a>
              ))}
            </div>
          </div>

        </div>

        {/* Sidebar */}
        <div className="dept-sidebar">

          {/* Department Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Department Details</div>
            {data.info.map((row, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{row.key}</span>
                <span className="dept-info-val">{row.val}</span>
              </div>
            ))}
          </div>

          {/* Fund Types */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Fund Accounts Maintained</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">📂 Fund-Wise Accounts</div>
              {data.funds.map((fund, i) => (
                <div className="dept-service-item" key={i} style={{ marginTop: "8px" }}>
                  {fund}
                </div>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Key Services</div>
            <div className="dept-services-grid">
              {data.services.map((s, i) => (
                <div className="dept-service-item" key={i}>{s}</div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="dept-contact-card">
            <div className="dept-contact-card-title">Contact Information</div>
            {data.contact.map((c, i) => (
              <div className="dept-contact-row" key={i}>
                <span>{c.icon}</span>
                <span>{c.label}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Footer */}
      <div className="dept-footer">
        <strong>Zilla Parishad Pune</strong> — Finance Department &nbsp;|&nbsp; Telephone: 020-26135426 &nbsp;|&nbsp; District Level Office
      </div>
    </div>
  );
}
